// GENERATED by tools/levels (pnpm levels:build). Do not edit by hand.
import type { TilePack } from "./schema.ts";

export const TILE_CONTENT_VERSION = "tiles-1.0.0";

/** sha256 of each frozen chapter pack, checked by `pnpm levels:check`. */
export const TILE_PACK_SHA256: Readonly<Record<number, string>> = {
  1: "0478cbe40c8fab0aec262da140456226de230f905df5a13ce5fa72e844b9a231",
  2: "1a9cffd529c9d35c59db8b266838cccbd2929da98eed3eb2c3d1a7b414fddf1d",
  3: "8f211751034a52eca5035f281ffd830192bb7a2ad27cbaca175569e3a2d31abd",
  4: "80b228a0339bfd26ba2a0ff4332086cb5b71ce8334fd62defbb30bb173b30077",
  5: "0c1a80f1d5874b246ea932ae74559c52cbd26eed68f4f4f09579bbe72aff397d",
  6: "3f81f16a16fda49688a4277d6b10673283f5df5b4059fb0407180d703de6c838",
  7: "c22f4a2882bb39cc4ff81ee1dba1f858a30b108fb29fa2e13e7971af7f1a2d51",
  8: "ab4891b4f3aba6e4a7ffd1bb4dcf0d96d78f318acf5a456da03ccc0ae08a3749",
  9: "718d08f076131959c533690a3d7f60dd208341ce8dd3028d5f529dcdc6152da0",
  10: "8409fdf7cd8badab746348b894f25be87d61840fa591596ba56a7fcacd6e324c",
};

/** Lazy loaders: the client only downloads the chapter being played. */
export const TILE_PACK_LOADERS: Readonly<Record<number, () => Promise<TilePack>>> = {
  1: () => import("../../packs/tiles/tiles-1.0.0/chapter-01.json").then((m) => m.default as TilePack),
  2: () => import("../../packs/tiles/tiles-1.0.0/chapter-02.json").then((m) => m.default as TilePack),
  3: () => import("../../packs/tiles/tiles-1.0.0/chapter-03.json").then((m) => m.default as TilePack),
  4: () => import("../../packs/tiles/tiles-1.0.0/chapter-04.json").then((m) => m.default as TilePack),
  5: () => import("../../packs/tiles/tiles-1.0.0/chapter-05.json").then((m) => m.default as TilePack),
  6: () => import("../../packs/tiles/tiles-1.0.0/chapter-06.json").then((m) => m.default as TilePack),
  7: () => import("../../packs/tiles/tiles-1.0.0/chapter-07.json").then((m) => m.default as TilePack),
  8: () => import("../../packs/tiles/tiles-1.0.0/chapter-08.json").then((m) => m.default as TilePack),
  9: () => import("../../packs/tiles/tiles-1.0.0/chapter-09.json").then((m) => m.default as TilePack),
  10: () => import("../../packs/tiles/tiles-1.0.0/chapter-10.json").then((m) => m.default as TilePack),
};
